import _defineProperty from "/drone/src/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["displayedDateVector", "onDisplayedDateVectorChange", "toggleMonthYearSelector"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useCallback, useEffect, useRef, useState } from 'react';
import { MONTH_NAMES_SHORT, YEAR_SELECTOR_RANGE_DELTA, YEAR_SELECTOR_SCROLL_TOP } from '../constants';
import { useVerticalScrollBoundariesObserver } from '../../../../system/hooks/useVerticalScrollBoundariesObserver';
import { extractNumericDataAttribute } from '../../utils/extractNumericDataAttribute';

var getInitialYearRange = function getInitialYearRange(year) {
  var yearRange = [];

  for (var i = year - 5; i <= year + 5; i += 1) {
    yearRange.push(i);
  }

  return yearRange;
};

export var useDatePickerMonthYearSelector = function useDatePickerMonthYearSelector(_ref, ref) {
  var displayedDateVector = _ref.displayedDateVector,
      onDisplayedDateVectorChange = _ref.onDisplayedDateVectorChange,
      toggleMonthYearSelector = _ref.toggleMonthYearSelector,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var displayedYear = displayedDateVector.year;
  var displayedMonth = displayedDateVector.month;

  var _useState = useState(getInitialYearRange(displayedYear)),
      _useState2 = _slicedToArray(_useState, 2),
      displayedRange = _useState2[0],
      setDisplayedRange = _useState2[1];

  useEffect(function () {
    setDisplayedRange(getInitialYearRange(displayedYear));
  }, [displayedYear]);
  var expandDisplayedRangeTop = useCallback(function () {
    var year = displayedRange[0];
    var previousYear = year - 1;
    var expansionRange = [];

    for (var i = previousYear; i >= previousYear - YEAR_SELECTOR_RANGE_DELTA; i -= 1) {
      expansionRange.unshift(i);
    }

    setDisplayedRange([].concat(expansionRange, _toConsumableArray(displayedRange)));
  }, [setDisplayedRange, displayedRange]);
  var expandDisplayedRangeBottom = useCallback(function () {
    var year = displayedRange[displayedRange.length - 1];
    var nextYear = year + 1;
    var expansionRange = [];

    for (var i = nextYear; i <= nextYear + YEAR_SELECTOR_RANGE_DELTA; i += 1) {
      expansionRange.push(i);
    }

    setDisplayedRange([].concat(_toConsumableArray(displayedRange), expansionRange));
  }, [setDisplayedRange, displayedRange]);
  var scrollRef = useRef(null);
  var listRef = useRef(null);
  useEffect(function () {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = YEAR_SELECTOR_SCROLL_TOP;
    }
  }, [scrollRef]);
  var boundariesObserverProps = useVerticalScrollBoundariesObserver(scrollRef, listRef, expandDisplayedRangeTop, expandDisplayedRangeBottom);
  var onMonthClick = useCallback(function (event) {
    var month = extractNumericDataAttribute(event, 'month');
    var year = extractNumericDataAttribute(event, 'year');

    if (month !== null && year !== null) {
      onDisplayedDateVectorChange(displayedDateVector.clone({
        year: year,
        month: month,
        day: 1
      }));
    }

    toggleMonthYearSelector();
  }, [displayedDateVector, onDisplayedDateVectorChange, toggleMonthYearSelector]);

  var _useState3 = useState(displayedYear),
      _useState4 = _slicedToArray(_useState3, 2),
      openYear = _useState4[0],
      setOpenYear = _useState4[1];

  var onYearClick = useCallback(function (event) {
    var year = parseInt(event.currentTarget.getAttribute('data-year'), 10);

    if (!Number.isNaN(year)) {
      setOpenYear(year);
    }
  }, [setOpenYear]);
  return {
    rootProps: _objectSpread(_objectSpread({}, restProps), {}, {
      ref: ref
    }),
    scrollProps: _objectSpread(_objectSpread({}, boundariesObserverProps), {}, {
      ref: scrollRef
    }),
    listProps: {
      ref: listRef
    },
    yearTitleProps: {
      onClick: onYearClick
    },
    monthProps: {
      onClick: onMonthClick
    },
    months: MONTH_NAMES_SHORT,
    yearRange: displayedRange,
    displayedYear: displayedYear,
    displayedMonth: displayedMonth,
    openYear: openYear
  };
};